import Index from '../components/NextTrips/Index'


let routes = {
    path: '/next-trips',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/next-trips',
            name: 'Próximas Viagens',
            component: Index,
        },

    ]
}

export default routes



// WEBPACK FOOTER //
// ./src/router/next_trips.js